import BaseTransformer from "./base.transformer"
import AccountDetailTransformer from "@/transformers/accountDetail.transformer"

export const baseUri = "/api/accounts"

export const subscriptionStatus = {
  0: "INACTIVE",
  1: "ACTIVE",
  2: "EXPIRED",
  3: "MANUAL",
  4: "CANCELLED",
  5: "TRIAL",
  6: "EXPIRED_TRIAL",
  7: "DOWNGRADED"
}

const accountStatus = {
  0: "FREE",
  1: "PREMIUM"
}

const getSubscriptionTypeDescription = (account) => {
  return account.subscriptionStatus === 2
    ? subscriptionStatus[account.subscriptionStatus]
    : accountStatus[account.status]
}
class AccountTransformer extends BaseTransformer {
  static fetch(account) {
    const uuid = this.transformUuid(account)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      hasCreatedFirstQr: account.hasCreatedFirstQr,
      features: account.features,
      totals: account.totals,
      status: account.status,
      subscriptionStatus: account.subscriptionStatus,
      subscriptionType: account.subscriptionType,
      premiumSince: account.premiumSince,
      expirationDate: account.expirationDate,
      planPrice: account.planPrice,
      users: account.users,
      billingInfo: account.billingInfo,
      invoices: account.invoices,
      paymentSources: account.paymentSources,
      paymentSource: account.paymentSources?.length ? account.paymentSources[0] : null,
      owner: account.owner,
      projects: account.projects,
      members: account.members,
      accessTokens: account.accessTokens,
      tags: account.tags,
      totalProjects: account.totalProjects,
      domains: account.domains,
      createdAt: account.createdAt,
      updatedAt: account.updatedAt,
      lastPaymentDate: account.lastPaymentDate,
      lastStatusDate: account.lastStatusDate,
      statusDescription: account.statusDescription,
      subscriptionStatusDescription: account.subscriptionStatusDescription,
      subscriptionTypeDescription:
        account.subscriptionTypeDescription ||
        getSubscriptionTypeDescription({
          subscriptionStatus: account.subscriptionStatus,
          status: account.status,
          ...account
        }),
      detail: account.detail
        ? AccountDetailTransformer.fetch(
            typeof account.detail === "string"
              ? { uuid: account.detail["@id"]?.split("/").pop() }
              : account.detail
          )
        : null
    })
  }
}

export default AccountTransformer
